import React from 'react';
import { PDFViewer } from '@react-pdf/renderer';
import ClassicTemplate from './templates/ClassicTemplate';
import ModernTemplate from './templates/ModernTemplate';
import DetailedTemplate from './templates/DetailedTemplate';

const templateMap = {
  classic: ClassicTemplate,
  modern: ModernTemplate,
  detailed: DetailedTemplate,
};

/**
 * Returns the raw PDF Document element for a given invoice (used for pdf().toBlob())
 */
export const InvoicePdfTemplate = ({ invoice }) => {
  const Template = templateMap[invoice.templateId] || ClassicTemplate;
  return <Template invoice={invoice} />;
};

/**
 * Renders a PDF preview inside a PDFViewer (for in-browser preview)
 */
const InvoicePdfDocument = ({ invoice }) => {
  const Template = templateMap[invoice.templateId] || ClassicTemplate;

  return (
    <PDFViewer width="100%" height={600} showToolbar={false}>
      <Template invoice={invoice} />
    </PDFViewer>
  );
};

export default InvoicePdfDocument;
